import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["TableOfContents","LegalSections","LegalSection"] */ "/opt/build/repo/src/app/terms/components.tsx");
